import { useQuery } from '@tanstack/react-query'
import { fetchRecentSuccesses, type SuccessEvent } from '@/services/scandals'

/**
 * Hook to fetch recent success events for a party.
 *
 * Returns successes that can be highlighted with PR actions.
 *
 * TODO: This returns empty data until the events table is implemented.
 *
 * @param partyId - The party ID to fetch successes for
 * @param currentTick - Current game tick for filtering
 */
export function useRecentSuccesses(partyId: string | undefined, currentTick: number | undefined) {
  const successesQuery = useQuery({
    queryKey: ['successes', 'recent', partyId, currentTick],
    queryFn: () => fetchRecentSuccesses(partyId!, currentTick!),
    enabled: !!partyId && currentTick !== undefined,
  })

  return {
    successes: successesQuery.data ?? [] as SuccessEvent[],
    isLoading: successesQuery.isLoading,
    error: successesQuery.error,
    hasSuccesses: (successesQuery.data?.length ?? 0) > 0,
  }
}
